(function () {

    'use strict';

    angular.module('fuzzysort', [])
        .provider('fuzzysort', FuzzysortProvider);

    FuzzysortProvider.$inject = [
        '$windowProvider'
    ];
    function FuzzysortProvider($windowProvider) {
        var $window = $windowProvider.$get();

        return {
            $get: function () {
                return $window.fuzzysort || {};
            }
        };
    }
})();
